
import React from 'react'
import ECWImage from './ECWImage/ECWImage'
import SuntTeaserListView from '../../blocks/ads/sunt/SuntTeaserListView'
import { AD_SETTINGS } from '../../../data/constants'

export default function ECListItem(props) {

  const { item, index, showSuggestion, hasHero } = props
  const shouldRenderHeroComponent = index === 0 && hasHero

  const showSundAdsOnPaginatedList = AD_SETTINGS.sunt?.showOnECList
  const suntAdsModulo = AD_SETTINGS.sunt?.showOnECListModulo

  return (
    <>
      {shouldRenderHeroComponent ? (
        <ECWImage
          imageColSpan={5}
          showPreHeadingImage={false}
          item={item}
          showSuggestion={showSuggestion}
        />
      ) : <ECWImage
        showPreHeadingImage={false}
        item={item}
      />}
      {showSundAdsOnPaginatedList && (index % suntAdsModulo == 0) && (
        <>
          <SuntTeaserListView id={(index / suntAdsModulo) + 1} />
        </>
      )}
    </>
  )
}
